import { render, staticRenderFns } from "./Come.vue?vue&type=template&id=1845c364&scoped=true&lang=html&"
import script from "./Come.vue?vue&type=script&lang=js&"
export * from "./Come.vue?vue&type=script&lang=js&"
import style0 from "./Come.vue?vue&type=style&index=0&id=1845c364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1845c364",
  null
  
)

export default component.exports